/** @deprecated Quarantined legacy (WEB-8048) — moved out of the Angular tree so the ReactTemplates.admin global survives Phase 6. Do not import in new code. */
'use strict';

/*
	WEB-9530: resolve the component statically rather than through window.AdminFieldPage.

	This module is evaluated from the React entry: index.js:17 imports ReactTemplatesShim, which
	imports the LegacyAdmin barrel, which imports this file. That import is hoisted above the
	require('./babel/legacy-dynamic-load') on index.js:41 — and legacy-dynamic-load is the only
	thing that pulls in Admin/Fields.js, whose module scope sets window.AdminFieldPage. So the
	global was always still undefined here, and AdminFields.tsx froze that undefined into its
	`LegacyFields` binding, rendering <undefined /> (React #130) whenever NEW_FIELDS was off.

	Importing the component directly removes the ordering dependency entirely. Admin/Fields.js is
	already loaded eagerly via legacy-dynamic-load, its module scope reads no window/Tools state,
	and it still assigns window.AdminFieldPage for any other reader of the global.
*/
export { default } from 'Components/Admin/Fields';
